import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
  ExportToExcel,
  dateFormatter,
  excelMapping,
  formatDateDDMMYYHHMM,
} from "../../utils/utilFuctions";
import { BASE_URL_API_TRANXT } from "../../utils/Constants";
import { CLIENT } from "../../config";
import { GlobalContext } from "../../Context/GlobalState";
import { DROP_SHADOW, offsetArr } from "../../utils/CommonConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import PGClaimModal from "./PGClaimModal";
export const columns = [
  {
    dataField: "payment_indate",
    text: "Date",
    color: "#000",
  },
  {
    dataField: "us_code",
    text: "User Code",
    color: "#000",
  },
  {
    dataField: "us_name",
    text: "User Name",
    color: "#000",
  },
  {
    dataField: "us_mobile",
    text: "User Mobile",
    color: "#000",
  },
  {
    dataField: "Reference",
    text: "Reference ID",
    color: "#000",
  },

  {
    dataField: "opening_bal",
    text: "Opening Balance",
    color: "#000",
  },
  {
    dataField: "amount",
    text: "Amount",
    color: "#000",
  },
  {
    dataField: "chages",
    text: "Charges",
    color: "#000",
  },
  {
    dataField: "gst",
    text: "GST",
    color: "#000",
  },
  {
    dataField: "closing_bal",
    text: "Closing Balance",
    color: "#000",
  },
  {
    dataField: "mode",
    text: "Mode",
    color: "#000",
  },
  {
    dataField: "status",
    text: "Status",
    color: "#000",
  },
  {
    dataField: "route_name",
    text: "Route Name",
    color: "#000",
  },

];
const tdstyle = {
  fontSize: "0.8rem",
  fontFamily: "Poppins",
  fontWeight: "400",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "center",
};

const tdstyle2 = {
  width: "10%",
  fontSize: "0.8rem",
  fontFamily: "Poppins",
  fontWeight: "400",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "center",
};

const thstyle = {
  color: "dark",
  backgroundColor: "white",
  fontFamily: "Poppins",
  fontSize: "16px",
  fontWeight: "700",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "center",
};

function PymentsGetwayReportTable() {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState({ open: false, aadhaar: "", order: "" });
  const [searchText, setSearchText] = useState("");
  const [offset, setOffset] = useState(10);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const { user } = useContext(GlobalContext);
  console.log(user);

  const getPgReport = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        fromdate: dateFormatter(startDate),
        todate: dateFormatter(endDate),
        mode: "",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        "https://apiservices.bumppypay.com/api/Payment/reports/getAllPGReport",
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setData(data.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getOrderDetails = async (orderid) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        orderId: orderid,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        "https://bumppy.in/api_integration/agent_concern/v1/getOrderInfo.php",
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setModalState({ ...modalState, open: true, aadhaar: data.data.cust_aadhaar, order: data.data })
      } else {
        setData([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // const fetchData = () => {
  //     fetchLedgerReport(startDate, endDate);
  //   };

  const now = (date = new Date()) => {
    return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
      }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };

  useEffect(() => {
    getPgReport();
  }, []);

  useEffect(() => {
    let filteredData = data.filter((bank) => {
      let b = false;
      if (data.length > 0) {
        for (let key in data[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toString().toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    setPages(Math.floor((filteredData.length + (offset - 1)) / offset));
    setTotal(filteredData.length);
    const startIdx = 0;
    const endIdx = offset - 1;
    filteredData = filteredData.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    setCurrentPage(1);
  }, [searchText]);

  useEffect(() => {
    let filteredData = data.filter((bank) => {
      let b = false;
      if (data.length > 0) {
        for (let key in data[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toString().toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    console.log(filteredData);
    const startIdx = (currentPage - 1) * offset;
    const endIdx = currentPage * offset - 1;
    console.log({ startIdx, endIdx });
    filteredData = filteredData.filter((bank, idx) => {
      console.log(idx, idx <= endIdx && idx >= startIdx);
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    console.log({ startIdx, endIdx });
  }, [currentPage]);

  // did mount
  useEffect(() => {
    setPages(Math.floor((data.length + (offset - 1)) / offset));
    const startIdx = 0;
    const endIdx = offset - 1;
    setTotal(data.length);
    console.log(startIdx);
    console.log(data);
    const filteredData = data.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    console.log(filteredData);
    setDataToDisplay(filteredData);
  }, [data, offset]);


  const openInNewTab = (data) => {
    console.log(data);
    data.rch_recharge_date = data.payment_indate;
    data.user_code = data.us_code;
    data.user_name = data.us_name;
    data.rch_amount = data.amount;
    data.service = "Payment Gateway"
    data.rch_account_no = "NA"
    data.rch_transaction_id = "NA";
    data.rch_ifsc_code = "NA"
    sessionStorage.setItem("print", JSON.stringify(data));
    localStorage.setItem("print", JSON.stringify(data));
    const newWindow = window.open(
      `/pages/pg/Print?id=${data.tid}&type=`,
      "",
      "height=600,width=800'"
    );
    if (newWindow) newWindow.opener = null;

  };





  const searchBarStyle = {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: "6px",
    padding: "0px",
    backgroundColor: "#fff",
    width: "25%", // Adjust the width as needed
    height: "20%",
  };
  const inputStyle = {
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    fontSize: "16px",
    marginLeft: "8px",
    width: "100%",
    fontFamily: "Poppins",
    fontWeight: "400",
  };
  const iconStyle = {
    color: "rgba(0, 0, 0, 0.5)",
  };

  const positionStyle1 = {
    position: "absolute",
    top: -43,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };
  const positionStyle2 = {
    position: "absolute",
    top: -30,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };

  const validate = (event) => {
    event.preventDefault();

    const form = event.target;
    form.submit();

    return false;
  };


  return (
    <>

      <PGClaimModal aadhaar={modalState.aadhaar} mdShow={modalState.open} setMdShow={(isOpen) => {
        setModalState({ ...modalState, open: isOpen })
      }} orderDetails={modalState.order}  callback={ ()=>{
        setModalState({...modalState,open:false});
        getPgReport();
      }}/>
      <div className="row m-0 p-0 pt-1 align-items-top">
        <div className="col-3 m-0 p-0">
          <div
            className="m-0 p-0 pl-3 align-top"
            style={{
              fontFamily: "Poppins",
              fontWeight: "600",
              lineHeight: "48px",
              letterSpacing: "0em",
              textAlign: "left",
              padding: "0px",
              background: "#FFFFFF",
              color: "#4267B2",
              fontWeight: "bolder",
              fontfamily: "Poppins !impotent",
              fontSize: "28px",
            }}
          >
            PG Report
          </div>
        </div>

        <div className="col-9 m-0 p-0 ">
          <div className="row  m-0 p-0  justify-content-end">
            <div style={searchBarStyle} className="bg-light m-0 p-0 pr-2">
              <FontAwesomeIcon
                icon={faSearch}
                style={iconStyle}
                className="ml-2"
              />
              <input
                type="text"
                className="form-control "
                placeholder="Search"
                aria-label="Search"
                style={inputStyle}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                value={searchText}
              />
            </div>

            <div
              className="pr-1 pl-2 p-0 m-0"
              style={{ width: "18%", height: "20%" }}
            >
              <Form.Group className="p-0 m-0">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  className="form-control rounded-100"
                  placeholderText="Start Date"
                />
              </Form.Group>
            </div>
            <div
              className="px-1  p-0 m-0"
              style={{ width: "18%", height: "20%" }}
            >
              <Form.Group className="p-0 m-0">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  className="form-control rounded-100"
                  placeholderText="End Date"
                />
              </Form.Group>
            </div>

            <div
              className="pl-1   p-0 m-0"
              style={{ width: "14%", height: "20%" }}
            >
              <Form.Group className="mt-0 p-0 m-0">
                <Button
                  className="rounded-50 btn btn-primary btn-lg btn-block "
                  onClick={getPgReport}
                >
                  {"Search"}
                </Button>
              </Form.Group>
            </div>

            <div
              className="m-0 p-0  hover-container"
              style={{ cursor: "pointer" }}
              onClick={() => {
                ExportToExcel(
                  `PG_Report_${now()}`,
                  excelMapping(data, columns)
                );
              }}
            >
              <img
                className="pl-1 p-0"
                src={require("../../../assets/images/download Icon.png")}
                style={{ width: `3.5rem`, height: "85%" }}
              />
              <div style={positionStyle1} className="hover-text bg-dark ">
                Export to Excel
              </div>

            </div>
          </div>
        </div>
      </div>


      <hr className="m-0 p-0" />
      <div className=" scroll-inner admin-fix-width transparent-table">
        <table className=" table table-borderless text-dark ">
          <tr className="justify-content-around borderless-table text-center border-bottom text-dark">
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}> {"Sr"}</th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Date Time
            </th>
            <th
              className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}
            >
              User
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Ref ID
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Before Balance
              {" "}
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Amount{" "}
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Charges
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              GST
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              After Balance{" "}
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Mode{" "}
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Status{" "}
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Route
            </th>
            <th className=" transparent-table text-center border-bottom  text-dark"
              style={thstyle}>
              Print
            </th>
          </tr>



          {dataToDisplay.map((e, ind) => (
            <tr className=" transparent-table border-bottom ">
              <td className="align-middle" style={tdstyle}>  {ind + 1}</td>
              <td className="align-middle" style={tdstyle}>
                {" "}
                <div className="d-flex flex-column align-items-center text-center">
                  <span className="text-center">{formatDateDDMMYYHHMM(e.payment_indate)}</span>
                </div>
              </td>
              <td className="align-middle" style={tdstyle}>
                {" "}
                <div className="d-flex flex-column align-items-center">
                  <span>{e.us_code}</span>
                  <span >{`${e.us_name}`}</span>
                  <span>{e.us_mobile}</span>
                </div>
              </td>

              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  <span>{e.Reference}</span>
                </div>
              </td>
              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  <span>{e.opening_bal}</span>
                </div>
              </td>
              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  {e.amount}
                </div>
              </td>
              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  <span>{e.chages}</span>
                </div>
              </td>
              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  {e.gst}
                </div>
              </td>
              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  {e.closing_bal}
                </div>
              </td>

              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  {e.mode}
                </div>
              </td>

              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center  m-0" >
                  {e.status == "Pending" || e.status == "Unclaimed" ? (
                    <span
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                        border: "1px solid",
                        backgroundColor: "rgba(254, 128, 36, 0.1)",
                        color: "rgba(254, 128, 36, 1)",
                        bordercolor: "rgba(254, 128, 36, 1)",
                      }}
                      className="p-2"
                    >
                      {`${e.status}`}
                    </span>
                  ) : e.status === "Failed" || e.status === "Failed" ? (
                    <span
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                        border: "1px solid",
                        backgroundColor: "rgba(255, 0, 0, 0.1)",
                        color: " rgba(255, 0, 0, 1)",
                        bordercolor: " rgba(255, 0, 0, 1)",
                      }} className="p-2"
                    >
                      {`${e.status}`}
                    </span>
                  ) : (
                    <span
                      style={{
                        width: "100%",
                        borderRadius: "5px",
                        border: "1px solid",
                        backgroundColor: "rgba(43, 193, 85, 0.1)",
                        color: "rgba(43, 193, 85, 1)",
                        bordercolor: "rgba(43, 193, 85, 1)",
                      }} className="p-2"
                    >
                      {`${e.status}`}
                    </span>
                  )}
                </div>
              </td>
              <td className="align-middle" style={tdstyle}>
                <div className="d-flex flex-column align-items-center">
                  {e.route_name}
                </div>
              </td>
              <td
                className="align-middle" style={tdstyle}
              >
                {e.claim_status == "N" && (
                  <Button
                    style={{
                      borderRadius: "5px",
                      border: "1px none",
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      color: "rgba(255, 164, 27, 1)",
                      bordercolor: "rgba(255, 255, 255, 1)",
                      fontSize: "4px !important",
                    }}
                    className="btn rounded-100  m-0 p-0"
                    onClick={() => {
                      getOrderDetails(e.orderid);
                    }}

                  >
                    {" "}
                    <div
                      className="hover-container"
                    >
                      <img
                        src={require("../../../assets/images/Rehit.png")}
                        style={{ width: "100%", height: "100%", borderRadius: "0px" }}
                      />
                      <div

                        style={positionStyle2} className="hover-text bg-dark text-center px-2 py-1 mb-2"
                      >
                        Claim
                      </div>
                    </div>
                  </Button>

                )}


                <Button
                  style={{
                    borderRadius: "5px",
                    border: "1px none",
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    color: "rgba(255, 164, 27, 1)",
                    bordercolor: "rgba(255, 255, 255, 1)",
                    fontSize: "4px !important",
                  }}
                  className="btn rounded-100  m-0 p-0"
                >
                  {" "}
                  <div
                    className="hover-container"
                    onClick={() => {
                      openInNewTab(e);
                    }}
                  >
                    <img
                      src={require("../../../assets/images/printer.png")}
                      style={{ width: "100%", height: "100%", borderRadius: "0px" }}
                    />
                    <div

                      style={positionStyle2} className="hover-text bg-dark text-center px-2 py-1 mb-2"
                    >
                      Print
                    </div>
                  </div>
                </Button>
              </td>
            </tr>
          ))}
          {data.length <= 0 && <NoDataFound />}
        </table>
      </div>
      <Pagination
        page={currentPage}
        limit={pages}
        callback={(page) => {
          setCurrentPage(page);
        }}
        count={dataToDisplay.length}
        total={total}
        callback2={(offsetValue) => {
          setOffset(offsetValue);
        }}
      />

      {/* <div
        className="card mt-3 scroll-inner fix-width"
        style={{
          border: "1px solid",
          width: "100%",
          borderRadius: "1rem",
        }}
      >
        <table
          className="dashboard-table-style"
          style={{ width: "100%", backgroundColor: "white" }}
        >
          <tr>
            <th style={{ fontSize: "0.9rem" }}> {"Sr"}</th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Date Time
            </th>
            <th
              className="text-left"
              style={{ fontSize: "0.9rem", width: "10px !important" }}
            >
              User
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Ref ID
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              After Balance{" "}
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Amount{" "}
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Charges
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              GST
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Before Balance{" "}
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Mode{" "}
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Status{" "}
            </th>
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Route
            </th>
          </tr>
          {data.map((e, ind) => (
            <tr>
              <td style={{ fontSize: "0.8rem", backgroundColor: "white" }}>
                {ind + 1}
              </td>
              <td style={{ fontSize: ".8rem" }}>
                {formatDateDDMMYYHHMM(e.payment_indate)}
              </td>
              <td
                className="text-left"
                style={{ fontSize: ".8rem", width: "25px" }}
              >
                <div className="d-flex flex-column align-items-center text-center">
                  <span>{e.us_code}</span>
                  <span className="text-bold">{`${e.us_name}`}</span>
                  <span>{e.us_mobile}</span>
                </div>
              </td>
              <td style={{ fontSize: ".8rem" }}>{e.Reference}</td>
              <td style={{ fontSize: ".8rem" }}>{e.opening_bal}</td>
              <td style={{ fontSize: ".8rem" }}>{e.amount}</td>
              <td style={{ fontSize: ".8rem" }}>{e.chages}</td>
              <td style={{ fontSize: ".8rem" }}>{e.gst}</td>
              <td style={{ fontSize: ".8rem" }}>{e.closing_bal}</td>
              <td style={{ fontSize: ".8rem" }}>{e.mode}</td>
              <td style={{ fontSize: "0.8rem" }}>
                <span
                  className={`badge text-light ${e.status == "Success"
                    ? "bg-success"
                    : e.status == "Failed"
                      ? "bg-danger"
                      : "bg-warning"
                    }`}
                  style={{ padding: ".8rem 2rem", borderRadius: "4rem" }}
                >
                  {`${e.status}`}
                </span>
              </td>
              <td style={{ fontSize: ".8rem" }}>{e.route_name}</td>

            </tr>
          ))}
        </table>

        <Pagination
          page={currentPage}
          limit={pages}
          callback={(page) => {
            setCurrentPage(page);
          }}
          count={dataToDisplay.length}
          total={total}
          callback2={(offsetValue) => {
            setOffset(offsetValue);
          }}
        />
      </div> */}
    </>
  );
}
const Pagination = ({ page, limit, callback, total, count, callback2 }) => {
  console.table({ page, limit, callback });

  const selectStyleLeftBorder = {
    borderRadius: "0px",
    fontFamily: "Poppins",
    fontsize: "16px",
    borderRight: "1px solid rgba(0, 0, 0, 0.2)", // Remove the border
    borderRadius: "0px",
    borderLeft: "none", // Remove right side border
    borderTop: "none", // Remove top border
    borderBottom: "none", // Remove bottom border
    fontFamily: "Poppins",
    fontsize: "16px",
  };
  const selectStyleBorder = {
    border: "1px solid rgba(0, 0, 0, 0.1)", // Remove the border
    borderRadius: "8px",
    fontFamily: "Poppins",
    fontsize: "16px",
  };
  const selectStyle = {
    border: "none", // Remove the border
    fontFamily: "Poppins",
    fontsize: "16px",
  };
  return (
    <div
      className="row"
      style={{
        display: "flex",
        alignItems: "end",
        width: "100%",
        margin: "10px 0px",
        justifyContent: "space-between",
      }}
    >
      <div style={{ fontFamily: "Poppins" }}>
        <strong>{`Showing ${count} of ${total} entries`}</strong>
      </div>

      <div className="d-flex btn-group p-1" style={selectStyleBorder}>
        <select
          style={selectStyleLeftBorder}
          className=" d-flex justify-content-end "
          aria-label="offset"
          onChange={(e) => {
            callback2(e.target.value);
          }}
        >
          {offsetArr.map((offset) => (
            <option value={offset} className="d-flex justify-content-end">
              {offset}
            </option>
          ))}
        </select>
        {page - 2 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            className="rounded-0 bg-white text-dark border-white"
          >
            {"<<"}
          </Button>
        ) : null}

        {page - 1 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            className="rounded-0 bg-white text-dark border-white underline-text"
          >
            {" "}
            {(page - 1).toString()}
          </Button>
        ) : null}

        <Button className="bg-white text-primary " style={selectStyle}>
          {" "}
          {page.toString()}
        </Button>

        {/* Next And Previous Button Code */}
        {page + 1 <= limit ? (
          <Button
            onClick={() => {
              callback(page + 1);
            }}
            className="rounded-0 bg-white text-dark border-white"
          >
            {">>"}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export const NoDataFound = () => {
  return (
    <tr className="row w-100 justify-content-center">
      <div className="d-flex flex-column align-items-center p-3">
        <img
          src={require("../../../assets/images/no_data_found.png")}
          style={{ height: "5rem", width: "auto" }}
        />
        <strong>No Data Found</strong>
      </div>
    </tr>
  );
};

export default PymentsGetwayReportTable;
